import { render } from "./PublicTemp.vue?vue&type=template&id=0d52aea9"
import script from "./PublicTemp.vue?vue&type=script&lang=js"
export * from "./PublicTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__